import React, { useCallback } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

// components
import NavMenu from "components/NavMenu";
import Snackbars from "components/Snackbar/Snackbar.js";

// Views
import BrandsView from "views/Brands/Brands";
import BrandsStationView from "views/BrandsStation/BrandsStation";
import BrandsSalesView from "views/BrandsSales/BrandSales";

// actions creators
import { clearError, setConfigTab } from "redux/ducks/brandsSection";
import { GlobalBox } from "components/Box/GlobalBox";
import { BrandsInputs } from "./BrandsInputs";
import SearchIcon from "@material-ui/icons/Search";
import { blue } from "@material-ui/core/colors";
const configTabs = [
  { id: "001", label: "Marcas", page: <BrandsView /> },
  { id: "002", label: "Marcas por planta", page: <BrandsStationView /> },
  { id: "003", label: "Marcas ventas", page: <BrandsSalesView /> },
];

const BrandsSection = () => {
  const dispatch = useDispatch();
  
  // selectors
  const { error, errorMessage } = useSelector(
    (state) => state.brandsSection,
    shallowEqual
  );
  const { tab } = useSelector((state) => state.brandsSection.config);

  // calls
  const clearSnackbar = useCallback(() => {
    dispatch(clearError());
  }, []);

  const handleChangeTabMemoized = useCallback(
    (event, newValue) => {
      dispatch(setConfigTab(newValue));
    },
    [dispatch]
  );
  const handleChangeTabIndexMemoized = useCallback(
    (index) => {
      dispatch(setConfigTab(index));
    },
    [dispatch]
  );

  return (
    <GlobalBox title="Marcas" icon={<SearchIcon />}>
      <BrandsInputs />
      <NavMenu
        value={tab}
        onChange={handleChangeTabMemoized}
        onChangeIndex={handleChangeTabIndexMemoized}
        color={blue[900]}
        configTabs={configTabs}
      />
      <Snackbars
        place="tr"
        color="danger"
        message={errorMessage}
        open={error}
        closeNotification={() => clearSnackbar()}
        close
      />
    </GlobalBox>
  );
};

export default BrandsSection;
